import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { UIError } from "./errors";

var Reservation = /*#__PURE__*/function () {
  function Reservation(config, axios) {
    _classCallCheck(this, Reservation);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Reservation, [{
    key: "getReservationRestaurants",
    value: function () {
      var _getReservationRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context.next = 4;
                return this.axios.get(this.config.postfix.RESERVATION_RESTAURANTS, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this === null || _this === void 0 ? void 0 : _this._processRestaurants(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getReservationRestaurants() {
        return _getReservationRestaurants.apply(this, arguments);
      }

      return getReservationRestaurants;
    }()
  }, {
    key: "getRestaurantTimeslots",
    value: function () {
      var _getRestaurantTimeslots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var _this2 = this;

        var restaurantNum, requestDate, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                restaurantNum = payload.restaurantNum, requestDate = payload.requestDate;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context2.next = 5;
                return this.axios.get(this.config.postfix.RESERVATION_RESTAURANT_TIMESLOTS, {
                  params: {
                    restaurantNum: restaurantNum,
                    requestDate: requestDate,
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this2 === null || _this2 === void 0 ? void 0 : _this2._processTimeslots(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRestaurantTimeslots(_x) {
        return _getRestaurantTimeslots.apply(this, arguments);
      }

      return getRestaurantTimeslots;
    }()
  }, {
    key: "getRestaurantAvailableslots",
    value: function () {
      var _getRestaurantAvailableslots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var _this3 = this;

        var reservationDate, reservationTime, restaurantNum, partySize, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                reservationDate = payload.reservationDate, reservationTime = payload.reservationTime, restaurantNum = payload.restaurantNum, partySize = payload.partySize;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 5;
                return this.axios.get(this.config.postfix.RESERVATION_AVAILABLE_TIMESLOTS, {
                  params: {
                    reservationDate: reservationDate,
                    reservationTime: reservationTime,
                    restaurantNum: restaurantNum,
                    partySize: partySize,
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this3 === null || _this3 === void 0 ? void 0 : _this3._processAvailableSlots(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getRestaurantAvailableslots(_x2) {
        return _getRestaurantAvailableslots.apply(this, arguments);
      }

      return getRestaurantAvailableslots;
    }()
  }, {
    key: "createReservation",
    value: function () {
      var _createReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(reqBody) {
        var _this4 = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 4;
                return this.axios.post(this.config.postfix.RESERVATIONS, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this4._processCreate(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createReservation(_x3) {
        return _createReservation.apply(this, arguments);
      }

      return createReservation;
    }()
  }, {
    key: "updateReservation",
    value: function () {
      var _updateReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(reqBody) {
        var _this5 = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context5.next = 4;
                return this.axios.put(this.config.postfix.RESERVATIONS, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this5._processCreate(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateReservation(_x4) {
        return _updateReservation.apply(this, arguments);
      }

      return updateReservation;
    }()
  }, {
    key: "getReservations",
    value: function () {
      var _getReservations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(reqBody) {
        var _this6 = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context6.next = 4;
                return this.axios.post(this.config.postfix.GET_RESERVATIONS, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this6 === null || _this6 === void 0 ? void 0 : _this6._processGetReservations(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context6.abrupt("return", _context6.sent);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getReservations(_x5) {
        return _getReservations.apply(this, arguments);
      }

      return getReservations;
    }()
  }, {
    key: "deleteReservation",
    value: function () {
      var _deleteReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
        var _this7 = this;

        var confirmationNumber, commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                confirmationNumber = payload.confirmationNumber;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context7.next = 5;
                return this.axios["delete"](this.config.postfix.RESERVATIONS, {
                  params: {
                    locale: locale,
                    confirmationNumber: confirmationNumber
                  }
                }).then(function (resp) {
                  return _this7._processCancelReservation(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteReservation(_x6) {
        return _deleteReservation.apply(this, arguments);
      }

      return deleteReservation;
    }()
  }, {
    key: "createNotification",
    value: function () {
      var _createNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(reqBody) {
        var _this8 = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context8.next = 4;
                return this.axios.post(this.config.postfix.RESERVATION_NOTIFICATION, reqBody, {
                  params: {
                    locale: locale
                  }
                }).then(function (resp) {
                  return _this8._processNotification(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context8.abrupt("return", _context8.sent);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createNotification(_x7) {
        return _createNotification.apply(this, arguments);
      }

      return createNotification;
    }() // reservation api processing methods

  }, {
    key: "_processTimeslots",
    value: function _processTimeslots(resp) {
      var _resp$data, _resp$data3;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.errors) {
        var _resp$data2;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.errors
        };
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.restaurantTimeslot;
    }
  }, {
    key: "_processAvailableSlots",
    value: function _processAvailableSlots(resp) {
      var _resp$data4, _resp$data6;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data4 = resp.data) !== null && _resp$data4 !== void 0 && _resp$data4.errors) {
        var _resp$data5;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.errors
        };
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.availableSlots;
    }
  }, {
    key: "_processNotification",
    value: function _processNotification(resp) {
      var _resp$data7;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data7 = resp.data) !== null && _resp$data7 !== void 0 && _resp$data7.errors) {
        var _resp$data8;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data8 = resp.data) === null || _resp$data8 === void 0 ? void 0 : _resp$data8.errors
        };
      }

      return true;
    }
  }, {
    key: "_processRestaurants",
    value: function _processRestaurants(resp) {
      var _resp$data9, _resp$data11;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data9 = resp.data) !== null && _resp$data9 !== void 0 && _resp$data9.errors) {
        var _resp$data10;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data10 = resp.data) === null || _resp$data10 === void 0 ? void 0 : _resp$data10.errors
        };
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data11 = resp.data) === null || _resp$data11 === void 0 ? void 0 : _resp$data11.restaurants;
    }
  }, {
    key: "_processCreate",
    value: function _processCreate(resp) {
      var _resp$data12, _resp$data14;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data12 = resp.data) !== null && _resp$data12 !== void 0 && _resp$data12.errors) {
        var _resp$data13;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data13 = resp.data) === null || _resp$data13 === void 0 ? void 0 : _resp$data13.errors
        };
      }

      return resp === null || resp === void 0 ? void 0 : (_resp$data14 = resp.data) === null || _resp$data14 === void 0 ? void 0 : _resp$data14.confirmationNumber;
    }
  }, {
    key: "_processGetReservations",
    value: function _processGetReservations(resp) {
      var _resp$data15, _resp$data17, _resp$data18;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data15 = resp.data) !== null && _resp$data15 !== void 0 && _resp$data15.errors) {
        var _resp$data16;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data16 = resp.data) === null || _resp$data16 === void 0 ? void 0 : _resp$data16.errors
        };
      }

      return {
        activeReservations: resp === null || resp === void 0 ? void 0 : (_resp$data17 = resp.data) === null || _resp$data17 === void 0 ? void 0 : _resp$data17.activeReservations,
        pastReservations: resp === null || resp === void 0 ? void 0 : (_resp$data18 = resp.data) === null || _resp$data18 === void 0 ? void 0 : _resp$data18.pastReservations
      };
    }
  }, {
    key: "_processCancelReservation",
    value: function _processCancelReservation(resp) {
      var _resp$data19, _resp$data21, _resp$data22;

      this._handleStatusMessageErrors(resp);

      if (resp !== null && resp !== void 0 && (_resp$data19 = resp.data) !== null && _resp$data19 !== void 0 && _resp$data19.errors) {
        var _resp$data20;

        throw {
          errors: resp === null || resp === void 0 ? void 0 : (_resp$data20 = resp.data) === null || _resp$data20 === void 0 ? void 0 : _resp$data20.errors
        };
      }

      if ((resp === null || resp === void 0 ? void 0 : (_resp$data21 = resp.data) === null || _resp$data21 === void 0 ? void 0 : _resp$data21.statusCode) === 200 && (resp === null || resp === void 0 ? void 0 : (_resp$data22 = resp.data) === null || _resp$data22 === void 0 ? void 0 : _resp$data22.statusMessage) === "Success") {
        return true;
      }

      return false;
    }
  }, {
    key: "_handleStatusMessageErrors",
    value: function _handleStatusMessageErrors(resp) {
      var _resp$data23;

      if ((resp === null || resp === void 0 ? void 0 : (_resp$data23 = resp.data) === null || _resp$data23 === void 0 ? void 0 : _resp$data23.statusCode) === 204) {
        var _resp$data24;

        throw new Error(resp === null || resp === void 0 ? void 0 : (_resp$data24 = resp.data) === null || _resp$data24 === void 0 ? void 0 : _resp$data24.statusMessage);
      }
    }
  }]);

  return Reservation;
}();

export { Reservation as default };